import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AppBar, Toolbar, Typography, Box, IconButton, Menu, MenuItem } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import Logo from "../images/nag_kitchen_logo.png";

const Navbar = () => {
    const location = useLocation();
    const [menuAnchor, setMenuAnchor] = useState(null);

    const handleMenuOpen = (event) => {
        setMenuAnchor(event.currentTarget);
    };

    const handleMenuClose = () => {
        setMenuAnchor(null);
    };

    const navItems = [
        { label: 'Home', path: '/' },
        { label: 'Login', path: '/login' },
        { label: 'Catering', path: '/cateringsEnquiry' },
        { label: 'Products', path: '/productlist' },
        { label: 'Subscription', path: '/subscription' },
        { label: 'Contact', path: '/contact' }
    ];

    return (
        <AppBar position="fixed" sx={{ backgroundColor: 'white' }}>
            <Toolbar>
                <Typography
                    variant="h4"
                    component="div"
                    sx={{
                        flexGrow: 1,
                        display: "flex",
                        alignItems: "center"
                    }}
                >
                    <img src={Logo} alt="Logo" style={{ height: "80px", marginRight: "10px" }} />
                    NAG's Kitchen
                </Typography>
                {/* Desktop Navigation */}
                <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 2 }}>
                    {navItems.map((item) => (
                        <Box
                            key={item.path}
                            component={Link}
                            to={item.path}
                            sx={{
                                padding: '8px 16px',
                                borderRadius: '5px',
                                backgroundColor: location.pathname === item.path ? 'rgba(0,0,0,0.1)' : 'transparent',
                                color: location.pathname === item.path ? '#ad7e4c' : '#383838',
                                textDecoration: 'none',
                                fontFamily: '"Ariel", sans-serif',
                                fontWeight: 600,
                                fontSize: '14px',
                                textTransform: 'uppercase',
                                transition: 'background-color 0.3s ease',
                                '&:hover': {
                                    backgroundColor: 'rgba(0,0,0,0.05)'
                                }
                            }}
                        >
                            {item.label}
                        </Box>
                    ))}
                </Box>

                {/* Mobile Navigation */}
                <IconButton
                    edge="start"
                    color="inherit"
                    aria-label="menu"
                    onClick={handleMenuOpen}
                    sx={{
                        display: { xs: 'block', md: 'none' },
                        color: '#ad7e4c', // Change to your desired color
                        '&:hover': {
                            backgroundColor: 'rgba(0,0,0,0.05)' // Optional: change hover background color
                        }
                    }}
                >
                    <MenuIcon />
                </IconButton>

                <Menu
                    anchorEl={menuAnchor}
                    open={Boolean(menuAnchor)}
                    onClose={handleMenuClose}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                >
                    {navItems.map((item) => (
                        <MenuItem
                            key={item.path}
                            onClick={handleMenuClose}
                            component={Link}
                            to={item.path}
                            sx={{
                                backgroundColor: location.pathname === item.path ? 'rgba(0,0,0,0.05)' : 'transparent',
                                color: location.pathname === item.path ? '#ad7e4c' : '#383838'
                            }}
                        >
                            {item.label}
                        </MenuItem>
                    ))}
                </Menu>
            </Toolbar>
        </AppBar>
    );
};

export default Navbar;